import MuiDialogActions from '@mui/material/DialogActions';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';

type DialogActionsProps = ComponentPropsWithoutRef<typeof MuiDialogActions>;
type DialogActionsRef = ComponentRef<typeof MuiDialogActions>;

const DialogActions = forwardRef<DialogActionsRef, DialogActionsProps>(
  (props, ref) => {
    return <MuiDialogActions ref={ref} {...props} />;
  },
);
DialogActions.displayName = 'DialogActions';
export default DialogActions;
